import React, { useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableLoader } from './tableLoader';
import CustomTableRow from './tableRow';
import { TableHeader } from './headerTable';
import { FieldGetters } from 'src/utils';
import { TableCell, TableRow } from '@mui/material';
import { EmptyText } from 'src/containers/styles';
import { useNavigate } from "react-router-dom";

interface SimpleTableProps<RowData> {
  columns: Column<RowData>[];
  rows: RowData[];
  onRowClick?(
    data: RowData,
    event?: React.MouseEvent<unknown, MouseEvent>
  ): void;
  onRowClick?(
    data: RowData,
    event?: React.MouseEvent<unknown, MouseEvent>
  ): void;
  onRowDelete?(data: RowData): void;
  onRowEdit?(data: RowData): void;
  onRowCheck?(data: RowData): void;
  onAllRowsChecked?(data: RowData[]): void;
  isLoading?: boolean;
  tableWidth?: string;
  tableHeight?: string;
  getters?: FieldGetters;
  withElevation?: boolean;
  withCheckBox?: boolean;
  withAction?: boolean;
  selectedItems?: RowData[];
  searchTerm?: string,
  isDashboard?: boolean

}

export interface Column<RowData> {
  title: React.ReactNode;
  field: string;
  render?(data: RowData): React.ReactNode;
}

export function SimpleTable<RowData>({
  columns,
  rows = [],
  onRowClick,
  onRowDelete,
  onRowEdit,
  onRowCheck,
  onAllRowsChecked,
  isLoading = false,
  tableWidth = '99%',
  tableHeight = '100%',
  getters,
  withElevation = true,
  withCheckBox = false,
  withAction = false,
  selectedItems = [],
  searchTerm,
  isDashboard = false
}: SimpleTableProps<RowData>) {
  const navigate = useNavigate();

  const isRowChecked = useCallback(
    (item: any) => selectedItems.findIndex((i: any) => i['id'] === item['id']) !== -1,
    [selectedItems]
  );
  const isDataToShowNotEmpty = rows && Array.isArray(rows) && rows?.length !== 0;


  const onCheckAllRows = (areAllRowsChecked: boolean) => {
    try {
      if (onAllRowsChecked) {
        areAllRowsChecked ? onAllRowsChecked(rows) : onAllRowsChecked([])
      }
    } catch (error) {
      
    }
  }

  const loadingColumns = () => {
    if(onRowDelete && onRowEdit){
      return columns.length + 2
    }else {
      return columns.length
    }

  }
  function handleRowClick(row: any): void {
    navigate(`/endpoints/list`);
  } 
  return (
    <TableContainer
      component={withElevation ? Paper : 'div'}
      sx={{ width: tableWidth, height: tableHeight }}
    >
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHeader
          columns={columns}
          withCheckBox={withCheckBox}
          asAction={withAction}
          onCheckAllRows={onCheckAllRows}
          areAllRowsChecked={rows?.length > 0 && selectedItems?.length === rows?.length}
        />
        {isLoading ? (
          <TableLoader rowDepth={3} cellDepth={loadingColumns()} />
        ):(
          <TableBody>
            {rows.map((row, rowIndex) => (
              <CustomTableRow
                key={rowIndex}
                columns={columns}
                row={row}
                onRowEdit={onRowEdit}
                onRowDelete={onRowDelete}
                onRowClick={onRowClick}
                onRowCheck={onRowCheck}
                getters={getters}
                withCheckBox={withCheckBox}
                isChecked={isRowChecked(row)}
              />
            ))}
             {!isDataToShowNotEmpty && searchTerm && (
                <TableRow>
                  <TableCell colSpan={columns.length + 1}>
                    <EmptyText>
                      No result found: <i className="highlighted">{searchTerm}</i>.{isDashboard ? <i className="highlighted !text-blue-500 ml-1 cursor-pointer" onClick={handleRowClick}>See more endpoints ?</i> : null}
                    </EmptyText>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        )}
      </Table>

    </TableContainer>
  );
}
